import { configureStore } from '@reduxjs/toolkit';
import promiseMiddleware from 'redux-promise-middleware';
import reactors from './reactors';
import trackMiddleware from '../features/tracking/trackMiddleware';
import createRootReducer from './masterReducer';

export function getStore() {
    const middleware = [trackMiddleware, promiseMiddleware];

    const store = configureStore({
        reducer: createRootReducer(),
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: false,
            }).concat(middleware),
        devTools: process.env.NODE_ENV !== 'production',
    });

    reactors.addToStore(store);

    return store;
}
